import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "4eefab971327a171adc04ea87e8fa9c3.jpg",
    width: 2048,
    height: 1376
});